// Code generated by cmd/bundle; DO NOT EDIT.
// Source: frontend/src/pages/public/pages.ts

import { Home } from "./Home.tsx";
import { Solutions } from "./Solutions.tsx";
import { AboutUs } from "./AboutUs.tsx";
import { Contact } from "./Contact.tsx";
import { Standings } from "./Standings.tsx";
import { Lineups } from "./Lineups.tsx";

// Body component for each public route, keyed by URL pathname. The client
// router (public.ts) renders these when navigating without a full reload.
export const publicRoutes: Record<string, () => unknown> = {
    "/": Home,
    "/public/solutions": Solutions,
    "/public/about-us": AboutUs,
    "/contact": Contact,
    "/public/standings": Standings,
    "/public/lineups": Lineups,
};

// <title> for each public route, applied by the client router on navigation
// (the first load gets its title from the server-rendered shell).
export const publicTitles: Record<string, string> = {
    "/": "Hotlap | Digital Solutions for Motorsport",
    "/public/solutions": "Solutions | Hotlap",
    "/public/about-us": "About Us | Hotlap",
    "/contact": "Contact Us | Hotlap",
    "/public/standings": "Standings | Hotlap",
    "/public/lineups": "Lineups | Hotlap",
};
